import { render, staticRenderFns } from "./ChannelSessionDialog.vue?vue&type=template&id=ee3676e0&"
import script from "./ChannelSessionDialog.vue?vue&type=script&lang=js&"
export * from "./ChannelSessionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports